import axios from "axios";

const API_URL = process.env.REACT_APP_API_URL || "http://localhost:8080";

/* ------------------------------------------
   GET MEMBERS
------------------------------------------- */
export async function getMembers(
  page = 1,
  pageSize = 10,
  search = "",
  searchBusiness = ""
) {
  try {
    const res = await axios.get(`${API_URL}/api/members`, {
      params: { page, pageSize, search, searchBusiness },
    });
    return res.data;
  } catch (error) {
    console.error("❌ getMembers Error:", error);
    return null;
  }
}

/* ------------------------------------------
   SEARCH SUGGESTIONS
------------------------------------------- */
export async function searchSuggestions(
  query: string,
  type: "name" | "business" = "name"
) {
  try {
    const res = await axios.get(`${API_URL}/api/members`, {
      params: {
        suggestions: true,
        type,
        search: query,
      },
    });

    return res.data?.data || [];
  } catch (error) {
    console.error("❌ searchSuggestions Error:", error);
    return [];
  }
}

/* ------------------------------------------
   GET SINGLE MEMBER
------------------------------------------- */
export async function getMember(id: string) {
  try {
    const res = await axios.get(`${API_URL}/api/members/${id}`);
    return res.data;
  } catch (error) {
    console.error("❌ getMember Error:", error);
    return null;
  }
}

/* ------------------------------------------
   CREATE MEMBER
------------------------------------------- */
export async function createMember(data: any, token: string) {
  try {
    const res = await axios.post(`${API_URL}/api/members`, data, {
      headers: { Authorization: "Bearer " + token },
    });
    return res.data;
  } catch (error) {
    console.error("❌ createMember Error:", error);
    return null;
  }
}

/* ------------------------------------------
   UPDATE MEMBER
------------------------------------------- */
export async function updateMember(id: string, data: any, token: string) {
  try {
    const res = await axios.put(`${API_URL}/api/members/${id}`, data, {
      headers: { Authorization: "Bearer " + token },
    });
    return res.data;
  } catch (error) {
    console.error("❌ updateMember Error:", error);
    return null;
  }
}

/* ------------------------------------------
   DELETE MEMBER
------------------------------------------- */
export async function deleteMember(id: string, token: string) {
  try {
    const res = await axios.delete(`${API_URL}/api/members/${id}`, {
      headers: { Authorization: "Bearer " + token },
    });
    return res.data;
  } catch (error) {
    console.error("❌ deleteMember Error:", error);
    return null;
  }
}
